import range from 'lodash/range';

import './Pagination.scss';

import ChevronLeft from './buttons/ChevronLeft';
import ChevronRight from './buttons/ChevronRight';
import FirstPage from './buttons/FirstPage';
import LastPage from './buttons/LastPage';
import PageButton from './buttons/PageButton';

export interface IPaginationProps {
  numberOfRecords: number;
  currentPage: number;
  itemsPerPage: number;
  onChangePage: (page: number) => void;
  maxPages?: number;
}

export default function Pagination(props: Readonly<IPaginationProps>) {
  const { numberOfRecords, currentPage, itemsPerPage, onChangePage, maxPages = 3 } = props;
  if (numberOfRecords <= itemsPerPage) {
    return null;
  }

  const changePageHandler = (page: number) => () => onChangePage(page);

  // total number of pages
  const numberOfPages = Math.ceil(numberOfRecords / itemsPerPage);

  const currentFirstPage = Math.floor((currentPage - 1) / maxPages) * maxPages + 1;
  const currentLastPage = Math.min(numberOfPages + 1, currentFirstPage + maxPages);
  // current array of pages
  const currentPages = range(currentFirstPage, currentLastPage);

  const pagination = currentPages.map((pageNum) => {
    const activeClass = currentPage === pageNum ? ' active' : '';
    return (
      <PageButton key={pageNum} className={activeClass} onClick={changePageHandler(pageNum)}>
        {pageNum}
      </PageButton>
    );
  });

  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === numberOfPages;

  return (
    <div className="pagination-container">
      <ul className="pagination">
        {numberOfPages > maxPages ? <FirstPage disabled={isFirstPage} onClick={changePageHandler(1)} /> : null}

        <ChevronLeft disabled={isFirstPage} onClick={changePageHandler(currentPage - 1)} />

        {pagination}

        <ChevronRight disabled={isLastPage} onClick={changePageHandler(currentPage + 1)} />

        {numberOfPages > maxPages ? (
          <LastPage disabled={isLastPage} onClick={changePageHandler(numberOfPages)} />
        ) : null}
      </ul>
    </div>
  );
}
